/* tslint:disable */
/* eslint-disable */
/* @relayHash 5474a20f2724115ad87eaaa6e356b4cd */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type EditSheetPage_worksheetQueryVariables = {
    identifier: string;
};
export type EditSheetPage_worksheetQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly id: string;
            readonly isAdmin: boolean;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"NavHeader_viewer" | "WorksheetEditor_viewer">;
    } | null;
    readonly worksheetByIdentifier: {
        readonly creator: {
            readonly id: string;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"WorksheetEditor_worksheet">;
    } | null;
};
export type EditSheetPage_worksheetQuery = {
    readonly response: EditSheetPage_worksheetQueryResponse;
    readonly variables: EditSheetPage_worksheetQueryVariables;
};



/*
query EditSheetPage_worksheetQuery(
  $identifier: String!
) {
  viewer {
    ...NavHeader_viewer
    ...WorksheetEditor_viewer
    user {
      id
      isAdmin
    }
  }
  worksheetByIdentifier(identifier: $identifier) {
    creator {
      id
    }
    ...WorksheetEditor_worksheet
    id
  }
}

fragment DraggableExercise_exercise on Exercise {
  id
  ...ExerciseSummary_exercise
}

fragment ExerciseSummary_exercise on Exercise {
  id
  worksheet {
    id
  }
  __typename
  ... on TranslationExercise {
    ...TranslationExerciseSummary_exercise
  }
  ... on WordOrderExercise {
    ...WordOrderExerciseSummary_exercise
  }
  ... on VocabExercise {
    ...VocabExerciseSummary_exercise
  }
  ... on MultipleChoiceExercise {
    ...MultipleChoiceExerciseSummary_exercise
  }
}

fragment FeedbackModal_viewer on Viewer {
  user {
    id
  }
}

fragment MultipleChoiceExerciseSummary_exercise on MultipleChoiceExercise {
  content {
    prompt
    choices {
      text
      isCorrect
    }
  }
}

fragment NavHeader_viewer on Viewer {
  ...FeedbackModal_viewer
  user {
    id
    username
    isAdmin
    createdAt
    isUpgradedTeacher
    accountType
    classroomMemberships {
      level
      classroom {
        id
        title
        identifier
      }
      id
    }
    worksheets(first: 1) {
      edges {
        node {
          id
        }
      }
    }
  }
}

fragment TranslationExerciseSummary_exercise on TranslationExercise {
  content {
    prompt
    correctAnswers
    scrambledParts
  }
}

fragment VocabExerciseSummary_exercise on VocabExercise {
  content {
    terms {
      word
      definition
      image {
        id
        url(size: SMALL_SQUARE)
      }
    }
  }
}

fragment WordOrderExerciseSummary_exercise on WordOrderExercise {
  content {
    correctAnswers
    scrambledParts
  }
}

fragment WorksheetEditor_viewer on Viewer {
  user {
    id
  }
}

fragment WorksheetEditor_worksheet on Worksheet {
  id
  title
  description
  identifier
  isPublished
  visibility
  password
  exercises {
    id
    __typename
    ... on MultipleChoiceExercise {
      content {
        prompt
        choices {
          text
          isCorrect
        }
      }
    }
    ... on TranslationExercise {
      content {
        prompt
        correctAnswers
        scrambledParts
      }
    }
    ... on WordOrderExercise {
      content {
        correctAnswers
        scrambledParts
      }
    }
    ... on VocabExercise {
      content {
        terms {
          word
          definition
          image {
            id
          }
        }
      }
    }
    ...DraggableExercise_exercise
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "identifier",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isAdmin",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "identifier",
    "variableName": "identifier"
  }
],
v4 = [
  (v1/*: any*/)
],
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "creator",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": (v4/*: any*/)
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "identifier",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "prompt",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "correctAnswers",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "scrambledParts",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EditSheetPage_worksheetQuery",
    "type": "Root",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "NavHeader_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "WorksheetEditor_viewer",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "worksheetByIdentifier",
        "storageKey": null,
        "args": (v3/*: any*/),
        "concreteType": "Worksheet",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "WorksheetEditor_worksheet",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "EditSheetPage_worksheetQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "username",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isUpgradedTeacher",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "classroomMemberships",
                "storageKey": null,
                "args": null,
                "concreteType": "ClassroomMembership",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "level",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "classroom",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Classroom",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "worksheets",
                "storageKey": "worksheets(first:1)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "WorksheetConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorksheetEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Worksheet",
                        "plural": false,
                        "selections": (v4/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "worksheetByIdentifier",
        "storageKey": null,
        "args": (v3/*: any*/),
        "concreteType": "Worksheet",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v1/*: any*/),
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isPublished",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "visibility",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "password",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "exercises",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "worksheet",
                "storageKey": null,
                "args": null,
                "concreteType": "Worksheet",
                "plural": false,
                "selections": (v4/*: any*/)
              },
              {
                "kind": "InlineFragment",
                "type": "MultipleChoiceExercise",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "content",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MultipleChoiceExerciseContent",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "choices",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MultipleChoiceExerciseChoice",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "text",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isCorrect",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "TranslationExercise",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "content",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TranslationExerciseContent",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "WordOrderExercise",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "content",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WordOrderExerciseContent",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "VocabExercise",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "content",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VocabExerciseContent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "terms",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VocabExerciseTerm",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "word",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "definition",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "image",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Image",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "url",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "size",
                                    "value": "SMALL_SQUARE"
                                  }
                                ],
                                "storageKey": "url(size:\"SMALL_SQUARE\")"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "EditSheetPage_worksheetQuery",
    "id": null,
    "text": "query EditSheetPage_worksheetQuery(\n  $identifier: String!\n) {\n  viewer {\n    ...NavHeader_viewer\n    ...WorksheetEditor_viewer\n    user {\n      id\n      isAdmin\n    }\n  }\n  worksheetByIdentifier(identifier: $identifier) {\n    creator {\n      id\n    }\n    ...WorksheetEditor_worksheet\n    id\n  }\n}\n\nfragment DraggableExercise_exercise on Exercise {\n  id\n  ...ExerciseSummary_exercise\n}\n\nfragment ExerciseSummary_exercise on Exercise {\n  id\n  worksheet {\n    id\n  }\n  __typename\n  ... on TranslationExercise {\n    ...TranslationExerciseSummary_exercise\n  }\n  ... on WordOrderExercise {\n    ...WordOrderExerciseSummary_exercise\n  }\n  ... on VocabExercise {\n    ...VocabExerciseSummary_exercise\n  }\n  ... on MultipleChoiceExercise {\n    ...MultipleChoiceExerciseSummary_exercise\n  }\n}\n\nfragment FeedbackModal_viewer on Viewer {\n  user {\n    id\n  }\n}\n\nfragment MultipleChoiceExerciseSummary_exercise on MultipleChoiceExercise {\n  content {\n    prompt\n    choices {\n      text\n      isCorrect\n    }\n  }\n}\n\nfragment NavHeader_viewer on Viewer {\n  ...FeedbackModal_viewer\n  user {\n    id\n    username\n    isAdmin\n    createdAt\n    isUpgradedTeacher\n    accountType\n    classroomMemberships {\n      level\n      classroom {\n        id\n        title\n        identifier\n      }\n      id\n    }\n    worksheets(first: 1) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment TranslationExerciseSummary_exercise on TranslationExercise {\n  content {\n    prompt\n    correctAnswers\n    scrambledParts\n  }\n}\n\nfragment VocabExerciseSummary_exercise on VocabExercise {\n  content {\n    terms {\n      word\n      definition\n      image {\n        id\n        url(size: SMALL_SQUARE)\n      }\n    }\n  }\n}\n\nfragment WordOrderExerciseSummary_exercise on WordOrderExercise {\n  content {\n    correctAnswers\n    scrambledParts\n  }\n}\n\nfragment WorksheetEditor_viewer on Viewer {\n  user {\n    id\n  }\n}\n\nfragment WorksheetEditor_worksheet on Worksheet {\n  id\n  title\n  description\n  identifier\n  isPublished\n  visibility\n  password\n  exercises {\n    id\n    __typename\n    ... on MultipleChoiceExercise {\n      content {\n        prompt\n        choices {\n          text\n          isCorrect\n        }\n      }\n    }\n    ... on TranslationExercise {\n      content {\n        prompt\n        correctAnswers\n        scrambledParts\n      }\n    }\n    ... on WordOrderExercise {\n      content {\n        correctAnswers\n        scrambledParts\n      }\n    }\n    ... on VocabExercise {\n      content {\n        terms {\n          word\n          definition\n          image {\n            id\n          }\n        }\n      }\n    }\n    ...DraggableExercise_exercise\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '9adb0b1a43ca10e9375aaa0b2933f3b4';
export default node;
